import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { formatPrice } from '../utils/priceFormatter';
import { useSponsor } from '../contexts/SponsorContext';
import { useTheme } from '../contexts/ThemeContext';
import { usePositionContext } from '../contexts/PositionContext';

interface LivePriceRightProps {
  selectedSymbol: string;
  currentPrice: string;
  priceChange: string;
  isPricePositive: boolean;
  priceColor: string;
  isRightPanelVisible?: boolean;
}

const LivePriceRight: React.FC<LivePriceRightProps> = ({
  selectedSymbol,
  currentPrice,
  priceChange,
  isPricePositive,
  priceColor,
  isRightPanelVisible = false,
}) => {
  const { isSponsorEnabled } = useSponsor();
  const { theme } = useTheme();
  const { openPositions, totalUnrealizedPnL } = usePositionContext();
  
  return (
    <div
      className="pt-0 mt-2">
        <div className={`theme-bg-secondary bg-opacity-95 p-3 py-0 rounded-lg z-10 shadow-xs border theme-border ${theme === 'light' ? 'border-gray-200' : 'border-gray-700'}`}>
        <div className="flex items-center space-x-2 justify-between">
            {/* Position P&L Section - Only show if there are open positions */}
            {openPositions.length > 0 && (
              <div className="flex items-center space-x-2 justify-start">
                <h2 className="text-xs font-medium theme-text-quaternary">
                    Unrealized P&L:
                </h2>
                <div className="flex items-center space-x-1">
                    <span className={`text-xs font-medium ${
                    totalUnrealizedPnL >= 0 ? 'text-[#2AB7A6]' : 'text-red-400'
                  }`}>
                    {totalUnrealizedPnL >= 0 ? '+' : ''}${totalUnrealizedPnL.toFixed(2)}
                  </span>
                </div>
              </div>
             )}
            <div className="flex items-center space-x-2 justify-start">
              <h2 className="text-xs font-medium theme-text-quaternary">
                  {selectedSymbol}
              </h2>
              <div className="flex items-center space-x-1">
                  <div className="w-2 h-2 bg-[#2AB7A6] rounded-full animate-pulse"></div>
                  <span className="text-xs text-[#2AB7A6]">LIVE</span>
              </div>
            </div>
            <div className="flex items-center space-x-2 justify-end">
            <div
              className={`w-30 text-right${!isSponsorEnabled ? ' text-xs' : ''}`}
              style={{ width: 80 }}
            >
                <span className={`live-price-text font-bold theme-text-primary transition-all duration-300 ${
                  !isSponsorEnabled ? 'text-sm' : ''
                }`}>
                <span
                  className={priceColor}
                  dangerouslySetInnerHTML={{ 
                    __html: formatPrice(parseFloat(currentPrice), selectedSymbol).replace(
                      /\$(\d+)/g, 
                      (match, digits) => `${parseInt(digits).toLocaleString()}`
                    )
                  }}
                />
                </span>
            </div>
            <div className="w-20--1">
                <span className={`text-sm font-medium flex items-center ${isPricePositive ? 'text-[#2AB7A6]' : 'text-red-400'}`}>
                {isPricePositive ? (
                    <TrendingUp className="h-3 w-3 mr-1" />
                ) : (
                    <TrendingDown className="h-3 w-3 mr-1" />
                )}
                {priceChange && priceChange !== 'NaN%' ? priceChange : '+0.00%'}
                </span>
            </div>
            </div>
        </div>       
        
        </div>
    </div>
  );
};

export default LivePriceRight;
